import { Component, OnInit } from "@angular/core";
import { MatSnackBar } from "@angular/material/snack-bar";
import { ActivatedRoute, Params, Router } from "@angular/router";
import { MasterService } from "src/app/services/master.service";
import { FormControl, FormGroup, Validators } from "@angular/forms";
import { FinancialYearModel } from "src/app/model/FinancialYearModel";

@Component({
  selector: "app-secure-financial-year-au",
  templateUrl: "./financial-year-au.component.html",
  styleUrls: ["./financial-year-au.component.scss"],
})
export class FinancialYearAUComponent implements OnInit {
  financialKey: number;
  pageMode: string;
  financialYearModel : FinancialYearModel;
  form: FormGroup = new FormGroup({});
  isSubmitDisabled: boolean = false;
  isLoading: boolean = false;
  
  constructor(
    private masterService: MasterService,
    private _snackBar: MatSnackBar,
    private route: ActivatedRoute,
    private router: Router
  ) {}

  ngOnInit() {
    this.route.params.subscribe((params: Params) => {
      this.financialKey = +params["key"];      
      if(this.financialKey) {
        this.masterService
        .getFinancialYearBykey(this.financialKey)
        .subscribe((data: any) => {
          if(data.status === 'SUCCESS') {
            this.financialYearModel = data;
            this.pageMode = "Edit";
            
            this.form.patchValue({
              displaySeq: this.financialYearModel.displaySeq,
              financialYear: this.financialYearModel.financialYear,
              assessmentYear: this.financialYearModel.assessmentYear,
            });
          }
          else {
            this.masterService.errorToast(data.errorMessage);
          }
        });
      }
      else {
        this.pageMode = "Add";
      }
    });
      
    this.form = new FormGroup({
      displaySeq: new FormControl(null, [Validators.required, Validators.min(0)]),
      financialYear: new FormControl(null, [Validators.required, Validators.maxLength(7)]),
      assessmentYear: new FormControl(null, [Validators.required, Validators.maxLength(7)]),
    });
  }

  onSubmit() {
    if (this.form.valid) {
      if(this.pageMode === 'Add') {
        this.save();
      }
      else {
        this.update();
      }
    } 
    else {
      this.isSubmitDisabled = false;
    }
  }

  async save() {
    this.masterService
    .saveFinancialYear({
      financialYear: this.form.value.financialYear,
      assessmentYear: this.form.value.assessmentYear,
      displaySeq: this.form.value.displaySeq
    })
    .subscribe((data: any) => {
        if(data.status === 'SUCCESS') {
          this.successToast();
          this.router.navigate(["/secure", "financial-year", "list"]);
        }
        else {
          this.isSubmitDisabled = false;
          this.errorToast(data.errorMessage);
        }
      }, error => {
        this.isSubmitDisabled = false;
        console.log(error);
        this.errorToast(error.error.errorMessage, 5*1000);
      });  
  }

  async update() {
    this.masterService
    .updateFinancialYear(this.financialKey, {
      financialYear: this.form.value.financialYear,
      assessmentYear: this.form.value.assessmentYear,
      displaySeq: this.form.value.displaySeq
    }).subscribe((data: any) => {
      if(data.status === 'SUCCESS') {
        this.successToast();
        this.router.navigate(["/secure", "financial-year", "list"]);
      }
      else {
        this.isSubmitDisabled = false;
        this.errorToast(data.errorMessage);
      }
    }, error => {
      this.isSubmitDisabled = false;
      console.log(error);
      this.errorToast(error.error.errorMessage, 5*1000);
    });    
  }

  async successToast() {
    await this._snackBar.open(
      "Financial Year saved successfully.",
      "Close", {
        horizontalPosition: "right",
        verticalPosition: "top",
        panelClass: "success-toast",
        duration: 3 * 1000,
      }
    );
  }

  async errorToast(errorMessage: string, dur?: number) {
    await this._snackBar.open(errorMessage, "Close", {
        horizontalPosition: "right",
        verticalPosition: "top",
        panelClass: "error-toast",
        duration: dur ? dur : 3 * 1000,
      }
    );
  }
  
}